export default __webpack_public_path__ + "static/media/less.5deb4b09.svg";